module.exports = {
	"imgNavPic": require("@/assets/data/img/product-article/product_menu_title.png"),
	"aNavMenu": {
		"/product": {
			"name": "接入服务",
			"imgHead":require("@/assets/data/img/product-article/iot接入服务.png"),
			"content": [{
				"name": "优势",
				"text": [
					"<b>软硬SDN</b>",
					"支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。",
					"<b>自动化部署</b>",
					"在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。",
					"<b>统一管理</b>",
					"使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。",
					"<b>多版本&二次开发</b>",
					"提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"
				]
			}, {
				"name": "应用",
				"text": [
					"<b>软硬SDN</b>",
					"支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。",
					"<b>自动化部署</b>",
					"在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。",
					"<b>统一管理</b>",
					"使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。",
					"<b>多版本&二次开发</b>",
					"提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"
				]
			}, {
				"name": "文档",
				"text": [
					"<b>软硬SDN</b>",
					"支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。",
					"<b>自动化部署</b>",
					"在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。",
					"<b>统一管理</b>",
					"使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。",
					"<b>多版本&二次开发</b>",
					"提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"
				]
			}, {
				"name": "案例",
				"text": [
					"<b>软硬SDN</b>",
					"支持纯软/软硬结合的SDN，所见即所得，极简操作，轻松享有属于自己的私有云环境，并提供100%的二层网络隔离，确保安全。",
					"<b>自动化部署</b>",
					"在进行横向扩展时，通过自动化部署实现即插即用。通过自动化管理工具，对应用及系统进行自动化刮泥，有效减少人力管理，切实节省时间并降低成本。",
					"<b>统一管理</b>",
					"使用简便的图形化工作界面，所有数据与资源都可一目了然，有效降低了管理的复杂度与人为故障的发生几率。",
					"<b>多版本&二次开发</b>",
					"提供多个版本可选，支持二次开发。提供面向不同需要用户的多个版本产品，所有版本都支持用户进行二次开发。"
				]
			}]
		},
		"/product/2": {
			"name": "云主机",
			"imgHead":require("@/assets/data/img/product-article/云主机.png"),
			"content": [{
				"name": "优势",
				"text": [
					"QM2D服务器 即quick link mobile to device；快速建立移动终端和设备的链接服务器。",
					"<b>标准功能：</b>",
					"*移动终端和设备连接的透明通道",
					"*设备和设备连接的透明通道",
					"*设备和设备连接的透明通道",
					"*设备管理功能",
					"*移动终端管理功能",
					"*实时数据展示功能。",
					"*设备实时状态监视功能。",
					"*APP使用权"
				]
			}, {
				"name": "配置",
				"text": [
					"暂无信息"
				]
			}, {
				"name": "实图",
				"text": [
					"暂无信息"
				]
			}, {
				"name": "应用",
				"text": [
					"暂无信息"
				]
			}, {
				"name": "文档",
				"text": [
					"暂无信息"
				]
			}, {
				"name": "案例",
				"text": [
					"暂无信息"
				]
			}]
		},
		"/product/3": {
			"name": "硬件产品",
			"child": {
				"/product/3_1": {
					"name": "物联网模块",
					"icon": "iconfont icon-wulianwangmokuai",
					"imgHead":require("@/assets/data/img/product-article/物联网模块.png"),
					"content": [{
						"name": "功能",
						"text": [
							"提供RS232、RS485、TTL、继电器接口，可直接与硬件对联，无需设置，双向反馈，实时透传数据。可连接传感模块、GPS定位模块，配合功能模块可实现自动化控制。"
						]
					}, {
						"name": "配置",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "实图",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "应用",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "文档",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "案例",
						"text": [
							"暂无信息"
						]
					}]
				},
				"/product/3_2": {
					"name": "物联网链接器",
					"icon": "iconfont icon-wulianwanglianjieqi",
					"imgHead":require("@/assets/data/img/product-article/物联网链接器.png"),
					"content": [{
						"name": "功能",
						"text": [
							"简易操作，简约设计，插上电源接入网络即完成安装，客户可根据设备类型及数据类型自主选择相应配置来连接设备。物联网链接器为数据传输提供4800、9600、38400、115200四种波特率，为设备连接提供了RS232、RS485、TTL、继电器接口，可直接与设备连接，无需设置，双向反馈，实时透传数据。"
						]
					}, {
						"name": "配置",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "实图",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "应用",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "文档",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "案例",
						"text": [
							"暂无信息"
						]
					}]
				}
			}
		},
		"/product/4": {
			"name": "软件产品",
			"child": {
				"/product/4_1": {
					"name": "Qiot Pro",
					"icon": "iconfont icon-QiotPro",
					"imgHead":require("@/assets/data/img/product-article/Qiotpro.png"),
					"content": [{
						"name": "功能",
						"text": [
							"二维码扫描轻松添加设备，多种添加方式，多种设备类型可选，可自定义设备控制UI。智能控制、场景控制、定时控制是Qiot的三大主要功能，用户可以使用Qiot对设备进行远程智能控制，可以将多个控制命令任意组合成一键场景控制，可以对设备的某个控制命令或场景进行定时执行。还可对正在开发或已完成开发的设备进行调试，通过设备发来的报文，将报文直接转化为控制控件（控制按钮或实时数据），在手机端即可实现极速轻量开发，所见即所得，弹指间实现应用开发。"
						]
					}, {
						"name": "平台",
						"text": [
							"支持iOS与Android系统手机端应用。"
						]
					}, {
						"name": "UI",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "文档",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "案例",
						"text": [
							"暂无信息"
						]
					}]
				},
				
				"/product/4_2": {
					"name": "必加锁",
					"icon": "iconfont icon-bijiasuo",
					"imgHead":require("@/assets/data/img/product-article/必加锁.png"),
					"content": [{
						"name": "功能",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "平台",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "UI",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "文档",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "案例",
						"text": [
							"暂无信息"
						]
					}]

				},
				"/product/4_3": {
					"name": "闪钥",
					"icon": "iconfont icon-shanyue",
					"imgHead":require("@/assets/data/img/product-article/闪钥.png"),
					"content": [{
						"name": "功能",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "平台",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "UI",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "文档",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "案例",
						"text": [
							"暂无信息"
						]
					}]

				},
				"/product/4_4": {
					"name": "物联网控制系统",
					"icon": "iconfont icon-wulianwangxitongpingtai",
					"imgHead":require("@/assets/data/img/product-article/物联网控制系统.png"),
					"content": [{
						"name": "功能",
						"text": [
							"这是一个物联网管理控制后台系统，与手机端Qiot智能控制软件同步数据，根据用户级别不同分为普通版、企业版与厂商版。普通版的管理控制后台主要用于设备管理及控制，企业版与厂商版更着重于用户管理与产品管理（进销存），还可以对用户的健康信息、使用习惯、地理位置分布以及产品使用状态、销售情况等进行统计与分析。我们还为企业版与厂商版提供增值定制服务，用户可根据需求对产品信息进行海量统计与多维度的大数据分析，为销售为用户体验提供更有价值的数据分析。"
						]
					}, {
						"name": "平台",
						"text": [
							"支持PC端应用。"
						]
					}, {
						"name": "UI",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "文档",
						"text": [
							"暂无信息"
						]
					}, {
						"name": "案例",
						"text": [
							"暂无信息"
						]
					}]

				},
			}
		},

	}
}


// WEBPACK FOOTER //
// ./src/assets/data/product-article.js